<div class="loader-wrapper flex justify-center items-center h-96">
  <div class="loader"></div>
</div>
